const deviceScrollStart = 992;

function init() {
    const services = document.querySelectorAll('.block-services');
    
    
    if(!services.length || document.body.offsetWidth < deviceScrollStart) {
        removeScrollAnimation();
    }else {
        services.forEach( (service) => initAnimation(service));
    }
}

function removeScrollAnimation(){
    const services = document.querySelectorAll('.block-services');

    services.forEach(service => {
        const serviceContainer = service.querySelector('.block-services__container');
        serviceContainer.style.height = 'auto';
        serviceContainer.classList.remove('has-scroll-animation');

        const pin = service.querySelector('.pin-spacer-services');
        if(pin) pin.remove();
    });
}

function initAnimation(service) {
    const container =  service.querySelector('.block-services__container');

    if(container.classList.contains('has-scroll-animation')) return;

    container.classList.add('has-scroll-animation');

    const items = container.querySelectorAll('.item');

    if(items.length < 1) return;
    const tempItem = items[0].cloneNode(true);

    createScrollHolder(container, tempItem, items[0]);

    const itemScroll = container.querySelector('.item-scroll');
    const containerHeight = container.offsetHeight;
    container.style.height = `${containerHeight}px`;

    const itemScrollHeight = itemScroll.offsetHeight;
    const startPin = (itemScrollHeight / 2);
    const pinDistance = containerHeight - itemScrollHeight;

    gsap.registerPlugin(ScrollTrigger);

    /* section */
    ScrollTrigger.create({
        trigger: container,
        start: `${startPin}px center`,
        end: "+=" + pinDistance,
        pin: itemScroll,
        id: "services",
    })

    const itemsScroll = gsap.utils.toArray(items);

    itemsScroll.forEach(item => {
        ScrollTrigger.create({
            trigger: item,
            start: "top center",
            end: "bottom center",
            scrub: 1,
            onEnter: (event) => {
                const el = event.trigger;

                const tempImage = el.querySelector('.image-container > img').cloneNode(true);
                changeScrollImage(tempImage);
            },
            onEnterBack: (event) => {
                const el = event.trigger;

                const tempImage = el.querySelector('.image-container > img').cloneNode(true);
                changeScrollImage(tempImage);
            }
        })
    });

    function changeScrollImage(image) {
        
        const imageScrollContainer = itemScroll.querySelector('.image-container');
        const scrollImage = imageScrollContainer.querySelector('img');
        
        if(image.getAttribute('src') === scrollImage.getAttribute('src')) return;

        imageScrollContainer.innerHTML = '';
        imageScrollContainer.appendChild(image);

        imageScrollContainer.style.opacity = 0;
        //animate
        gsap.to(imageScrollContainer,{
            opacity: 1,
        });
    }
}

function createScrollHolder(container, newNode, referenceNode){
    if(!referenceNode) return;

    container.insertBefore(newNode, referenceNode);

    const items = container.querySelectorAll('.item');
    
    items[0].querySelector('.content').remove();
    items[0].classList.add('item-scroll');
}

document.addEventListener( 'DOMContentLoaded', () => {
    let wait = false;
    const delay = 1500;

    init();

    onresize = () => {
        if (wait) return;

        init();
        wait = true;
        setTimeout(function () {
            wait = false;
        }, delay);
    };


    // create an Observer instance
    const resizeObserver = new ResizeObserver(() => {
        if(document.body.offsetWidth <= deviceScrollStart) return;
        
        removeScrollAnimation();
        
        const services = document.querySelectorAll('.block-services');
        services.forEach( (service) => initAnimation(service));
    });
    
    // start observing a DOM node
    resizeObserver.observe(document.body)
} );
